import { useTranslation } from 'react-i18next';
import { InlineAnchor, Typography } from '@figure/frontlib-gui';
import ReviewAppBase from '../components/ReviewAppBase';

const NoCreditContainer = () => {
  const [t] = useTranslation();

  return (
    <ReviewAppBase>
      <Typography.Body>
        We were unable to pull your credit information using the last 4 digits of your social security number you provided. Our
        Customer Support Team will be happy to help resolve this issue. Please contact us at{' '}
        <InlineAnchor href={`tel:+${t('phone.unformatted')}`}>{t('phone.formatted')}</InlineAnchor> Monday - Sunday between 6am - 6pm
        PT. We hope to be able to serve you!
      </Typography.Body>
    </ReviewAppBase>
  );
};

export default NoCreditContainer;
